import { Box, Grid, Heading } from '@chakra-ui/react';
import { Label } from 'components/elements/Label';
import { Link } from 'components/elements/Link';
import { Text } from 'components/elements/Text';
import { ContactIcon } from 'components/icons/ContactIcon';
import { InfoModal } from 'components/widgets/InfoModal';
import { useContact } from 'hooks/useContacts';
import { useModal } from 'hooks/useModal';
import { EVENT_NAMES } from 'services/analytics/eventNames';
import { trackEvent } from 'services/analytics/trackEvent';

export const ContactInfo = () => {
  const {
    model: contact,
    Skeleton,
    ...modalProps
  } = useModal({
    queryParam: 'contactInfo',
    dataHook: useContact,
  });

  const trackContactEvent = (contactMethod: string) => {
    trackEvent(EVENT_NAMES.COMPANY_CONTACT, {
      employeeId: contact.result?.uuid,
      companyProfileId: contact.result?.office.company?.id,
      contactMethod,
    });
  };

  return (
    <InfoModal
      {...modalProps}
      header={
        <>
          <Box>
            <ContactIcon width="30px" height="30px" />
          </Box>
          <Skeleton variant="text" width="20rem" height="3rem">
            <Grid
              flexDirection="column"
              sx={{
                padding: '1rem',
              }}
            >
              <Heading size="md">
                {contact.result?.first_name} {contact.result?.last_name}
              </Heading>
            </Grid>
          </Skeleton>
        </>
      }
    >
      <Box>
        <InfoModal.Row>
          <Label fontWeight="semibold" fontSize={12} textTransform="capitalize">
            Position
          </Label>
          <InfoModal.RowDetails>
            <Skeleton variant="text">
              <Text>{contact.result?.title}</Text>
            </Skeleton>
          </InfoModal.RowDetails>
        </InfoModal.Row>
        <InfoModal.Row>
          <Label fontWeight="semibold" fontSize={12} textTransform="capitalize">
            Company
          </Label>
          <InfoModal.RowDetails>
            <Skeleton variant="text">
              <Text>{contact.result?.office.company?.name}</Text>
            </Skeleton>
          </InfoModal.RowDetails>
        </InfoModal.Row>
        <InfoModal.Row>
          <Label fontWeight="semibold" fontSize={12} textTransform="capitalize">
            Email
          </Label>
          <InfoModal.RowDetails
            data-testid="email-link"
            onClick={() => trackContactEvent('email')}
          >
            <Skeleton variant="text">
              <Link to={`mailto:${contact.result?.email}`}>
                <Text color="brand.army-green">{contact.result?.email}</Text>
              </Link>
            </Skeleton>
          </InfoModal.RowDetails>
        </InfoModal.Row>
        <InfoModal.Row>
          <Label fontWeight="semibold" fontSize={12} textTransform="capitalize">
            Office Phone
          </Label>
          <InfoModal.RowDetails
            data-testid="phone-link"
            onClick={() => trackContactEvent('phone')}
          >
            <Skeleton variant="text">
              <Link to={`tel:${contact.result?.office.phone}`}>
                <Text color="brand.army-green">{contact.result?.office.phone}</Text>
              </Link>
            </Skeleton>
          </InfoModal.RowDetails>
        </InfoModal.Row>
        {contact.result?.linkedin && (
          <InfoModal.Row>
            <Label fontWeight="semibold" fontSize={12} textTransform="capitalize">
              Social Profiles
            </Label>
            <InfoModal.RowDetails
              data-testid="social-link"
              onClick={() => trackContactEvent('linkedin')}
            >
              <Link to={contact.result.linkedin}>
                <Text color="brand.army-green">LinkedIn</Text>
              </Link>
            </InfoModal.RowDetails>
          </InfoModal.Row>
        )}
      </Box>
    </InfoModal>
  );
};
